import { Component, HostListener, OnInit } from '@angular/core';
import { StepService } from '../step.service';

@Component({
  selector: 'app-next-btn',
  templateUrl: './next-btn.component.html',
  styleUrls: ['./next-btn.component.scss']
})
export class NextBtnComponent implements OnInit {

  constructor(public stepService: StepService) { }

  ngOnInit(): void {
  }

  // @HostListener('click') onClick() {
  //   if (this.stepService.stepValidator()) {
  //     this.stepService.nextStep();
  //   }
  // }

}
